<!-- src/components/Button.vue -->

<template>
    <section class="column-wrapper">
        <slot></slot>
    </section>
</template>

<script>
export default { }
</script>

<style>
    
.column-wrapper {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
}
        
.column {
  flex-grow: 1;
}
    
.column-title {
  font-size: 14px;
  color: var(--primary-color1);
  font-weight: 500;
  padding: 10px 20px;
  border-bottom: 1px solid #E8E8E8;
  display: block;
  min-height: 40px;
}
        
.column-row {
  padding: 10px 20px;
}

.column-row-title {
  font-size: 12px;
  color: #888888;
  font-weight: 600;
  padding: 5px 0px 2px;
}
    
.column-row-value {
  font-size: 14px;
  color: #4A4A4A;
  padding: 0px 0px 5px;
  line-height: 24px;
  border-bottom: 1px solid #E8E8E8;
}
        
</style>
